import React from "react";
import { connect } from "react-redux";
import { paymentProvider } from "state/school_money/selectors";

import ModalDialog from "components/ModalDialog";
import PaysafePayment from "components/school_money/basket/checkout/paysafe/PaymentForm";
import SecureTradingPayment from "components/school_money/basket/checkout/secure_trading/PSD2PaymentForm";
import CheckoutInformationModal from "components/school_money/basket/checkout/CheckoutInformationModal";

class CheckoutWindow extends React.Component {

  render() {
    const { paymentProvider } = this.props;

    return (
      <React.Fragment>
          <ModalDialog fitScreen={true}>
            { paymentProvider === "ps" ? <PaysafePayment schoolID={this.props.schoolID} /> : <SecureTradingPayment schoolID={this.props.schoolID} /> }
          </ModalDialog>
        <CheckoutInformationModal />
      </React.Fragment>
    )
  }
}

export default connect(
  (state, { schoolID }) => ({
    paymentProvider: paymentProvider(state, schoolID)
  })
)(CheckoutWindow);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/CheckoutWindow.js